import { createLocaleController } from "@airange/shared/locale";
import { getLocale, type AppLocale } from "@airange/shared/i18n-exam-admin";
import { setLocale as setUmiLocale } from "@@/plugin-locale";
import { useSyncExternalStore } from "react";
import { getStoredLocale, setStoredLocale } from "./session";

function toUmiLocale(locale: AppLocale) {
  if (locale === "en") return "en-US";
  if (locale === "ja") return "ja-JP";
  return "zh-CN";
}

const baseLocaleController = createLocaleController({
  getStoredLocale,
  setStoredLocale,
});

const localeController = {
  ...baseLocaleController,
  initializeLocale: () => {
    const locale = baseLocaleController.initializeLocale();
    setUmiLocale(toUmiLocale(locale), false);
    return locale;
  },
  switchLocale: (locale: string) => {
    const nextLocale = baseLocaleController.switchLocale(locale);
    setUmiLocale(toUmiLocale(nextLocale), false);
    return nextLocale;
  },
};

let initialized = false;

export const adminLocaleOptions = localeController.localeOptions;

export function initializeAdminLocale() {
  if (initialized) {
    return getLocale();
  }
  initialized = true;
  return localeController.initializeLocale();
}

export const switchAdminLocale = localeController.switchLocale;

export function useAdminLocale() {
  return useSyncExternalStore(
    localeController.subscribeLocaleChange,
    localeController.getLocaleSnapshot,
    localeController.getLocaleSnapshot,
  );
}
